import { render } from "./AlarmsList.vue?vue&type=template&id=2ca66826"
import script from "./AlarmsList.vue?vue&type=script&lang=js"
export * from "./AlarmsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__